// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"aeaca02b","115":"80978f97","205":"53f7d236","240":"1562feb4","295":"70d0ad54","405":"f6aa4dfb","563":"373b21e7","589":"54494184","597":"cb520933","666":"45181564","667":"71754737","972":"f0797d0f"}[chunkId] + ".chunk.js";
};